import { EntryComponent, Assessment, QualificationMin } from '@cambridgeassessment/lib-ee-commons';
import { DownloadData, Section } from '../../types/Sections';

export const SET_QUALIFICATIONS = '@SECTIONS/SET_QUALIFICATIONS';
export const SET_ASSESSMENTS = '@SECTIONS/SET_ASSESSMENTS';
export const SET_COMPONENTS = '@SECTIONS/SET_COMPONENTS';
export const SET_SECTIONS = '@SECTIONS/SET_SECTIONS';
export const SET_ARE_FILES_LOADING = '@SECTIONS/SET_ARE_FILES_LOADING';
export const SET_FILE_RESULTS = '@SECTIONS/SET_FILE_RESULTS';
export const SET_FILES_TOTAL = '@SECTIONS/SET_FILES_TOTAL';
export const SET_FILES_NEXT_PAGE_URL = '@SECTIONS/SET_FILES_NEXT_PAGE_URL';
export const SET_IS_DOWNLOAD_FILES_LOADING = '@SECTIONS/SET_IS_DOWNLOAD_FILES_LOADING';

interface SetQualifications {
  type: typeof SET_QUALIFICATIONS;
  payload: {
    qualifications: QualificationMin[];
  };
}

interface SetAssessments {
  type: typeof SET_ASSESSMENTS;
  payload: {
    assessments: Assessment[];
  };
}

interface SetComponents {
  type: typeof SET_COMPONENTS;
  payload: {
    components: EntryComponent[];
  };
}

interface SetSections {
  type: typeof SET_SECTIONS;
  payload: {
    sections: Section[];
  };
}

interface SetAreFilesLoading {
  type: typeof SET_ARE_FILES_LOADING;
  payload: {
    isLoading: boolean;
  };
}

interface SetFileResults {
  type: typeof SET_FILE_RESULTS;
  payload: {
    fileResults: DownloadData[] | undefined;
  };
}

interface SetFilesTotal {
  type: typeof SET_FILES_TOTAL;
  payload: {
    total: number;
  };
}

interface SetFilesNextPageUrl {
  type: typeof SET_FILES_NEXT_PAGE_URL;
  payload: {
    nextUrl?: string;
  };
}
interface SetIsDownloadAllLoading {
  type: typeof SET_IS_DOWNLOAD_FILES_LOADING;
  payload: {
    isLoading: boolean;
  };
}

export type SectionsActionTypes =
  | SetQualifications
  | SetAssessments
  | SetComponents
  | SetSections
  | SetFileResults
  | SetAreFilesLoading
  | SetFilesTotal
  | SetFilesNextPageUrl
  | SetIsDownloadAllLoading;
